import { AsyncPipe, DatePipe, NgClass, NgFor, NgIf } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TrackingCmsComponents } from '@core/const';
import { SdvorButtonComponent } from '@sdvor/shared/ui';
import { CmsConfig, ConfigModule, UrlModule } from '@spartacus/core';
import { DateIntervalPipe } from './date-interval/date-interval.pipe';
import { TrackingDeliveryComponent } from './tracking-delivery.component';

@NgModule({
  declarations: [TrackingDeliveryComponent, DateIntervalPipe],
  imports: [
    NgIf,
    NgFor,
    NgClass,
    AsyncPipe,
    DatePipe,
    SdvorButtonComponent,
    RouterLink,
    UrlModule,
    ConfigModule.withConfig(<CmsConfig>{
      cmsComponents: {
        [TrackingCmsComponents.SdCMSTrackingComponent]: {
          component: TrackingDeliveryComponent,
        },
      },
    }),
  ],
  providers: [DatePipe],
})
export class TrackingDeliveryComponentModule {}
